export const Scenarios = {
    One: 'one',
    Two: 'two',
    Three: 'three',
    Four: 'four'
};

export const ScenarioType = {
    Stats: 'Stats',
    TopFiveRms: 'TopFiveRms',
    DetailView: 'DetailView'
};

export const ChartType = {
    VC: 'vc',
    BreachCategory: 'breachcategory',
    Trend: 'trend',
    Outliers: 'outliers',
    PortfolioBox: 'portfolioBox'
};

export const FilterType = {
    ZONE: 'zone',
    MARKET: 'market',
    TEAM: 'team',
    RM: 'rm'
};

export const FilterDisplay = {
    ZONE: 'Region',
    MARKET: 'Market',
    TEAM: 'Team',
    RM: 'CTO Code',
    USER_PROFILE_ZONE: 'User Profile Region'
};

export const StatBarDisplay = {
    MARKET: 'Market',
    TEAM: 'Team',
    RM: 'RM'
};

export const RMCardGroupDataType = {
    Default: 'default',
    TopFiveRms: 'topFiveRms',
    TopFiveEmergingMajorRm: 'topFiveEmergingMajorRm',
    TopFiveEmergingModerateRm: 'topFiveEmergingModerateRm',
    TopFiveRmsSpike: 'topFiveRmsSpike',
    Alerts: 'alerts'
};

export const RMCardGroupTooltipType = {
    Default: 'default',
    ScoreDecomposition: 'scoreDecomposition',
    TrendAnalysis: 'trendAnalysis'
};

export const TopFiveRmsCategory = {
    Concentration: 'concentration',
    Portfolio: 'portfolio',
    TotalScore: 'totalScore'
};

export const sortTypes = {
    asc: 'asc',
    desc: 'desc'
};

export const dataTypes = {
    date: 'date',
    number: 'number',
    string: 'string'
};

export const DecisionIconType = {
    tick: 'tick',
    cross: 'cross'
};

export const PeerComparisonTooltipType = {
    market: 'Market',
    team: 'Team',
    rm: 'RM'
};
